<template>
  <component v-on="$listeners" :is="tag" :to="to">
    <SvgIcon v-if="icon" :iconName="icon" class="svg-icon"></SvgIcon>
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'HPButton',
  props: {
    tag: {
      type: String,
      default: 'button'
    },
    to: { type: [String, Object] },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1rem;
  height: 1rem;
  fill: currentColor !important;
  overflow: hidden;
}
</style>
